import type * as FormModule from '../types/FormModule'

export default function formModuleComponentParser(
  rawComponent: FormModule.Raw,
): FormModule.Parsed {
  const props = rawComponent.formModule
  const [form] = props[0].acf.form

  return {
    name: 'FormModule',
    props: {
      components: form.elements.map((element) => {
        switch (element.acfFcLayout) {
          case 'text_block':
            return {
              name: 'TextBlock',
              props: {
                children: element.text,
              },
            }
          case 'section_headline':
            return {
              name: 'SectionHeadline',
              props: {
                children: element.text,
              },
            }
          case 'form_field': {
            const {
              errorText,
              isRequired,
              labelText,
              placeholder,
              key,
            } = element

            const baseFormFieldProps = {
              errorText,
              fieldId: key,
              isRequired,
              labelText,
              placeholder,
            }

            switch (element.type) {
              case 'input': {
                const { inputType } = element

                return {
                  name: 'Input',
                  props: {
                    ...baseFormFieldProps,
                    inputType,
                  },
                }
              }

              case 'dropdown': {
                const { options } = element

                return {
                  name: 'Dropdown',
                  props: {
                    ...baseFormFieldProps,
                    options,
                  },
                }
              }

              case 'radio': {
                const { options } = element

                return {
                  name: 'Radio',
                  props: {
                    ...baseFormFieldProps,
                    options,
                  },
                }
              }

              case 'dropdownCC':
                return {
                  name: 'CountryDropdown',
                  props: baseFormFieldProps,
                }

              case 'textArea':
                return {
                  name: 'TextArea',
                  props: baseFormFieldProps,
                }
            }
          }
        }
      }),
      recaptcha: form.settings.hasRecaptcha
        ? form.settings.recaptcha
        : undefined,
      submitButtonText: form.settings.submit.labelText,
      submitUrl: form.settings.submit.formSubmitApi,
      invalidText: form.settings.submit.errorMessages.invalidField,
      errorText: form.settings.submit.errorMessages.invalidRequest,
      successText: form.settings.submit.submitSuccessText,
    },
  }
}
